import {useSelector} from "react-redux";
import {financeSelector} from "../../../../redux/slices/financeSlice";
import {globalDataSelector} from "../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
import s from "./assignRecordToUserPopup.module.scss";
import React, {useEffect, useState} from "react";
import SvgSelector from "../../../SvgSelector/SvgSelector";
import CancelButton from "../../Buttons/CancelBtn/CancelBtn";
import PrimaryBtn from "../../Buttons/PrimaryBorderBtn/PrimaryBorderBtn";
import Select from "react-select";
import {redirectDropdownStyles} from "../GetLinksPopup/GetLinksPopup";
import {useSelectOptions} from "../../../../utils/helpers/useSelectHelpers";
import { teamsSelector} from "../../../../redux/slices/teamsSlice";
import {useFormik} from "formik";
import * as Yup from "yup";

const AssignRecordToUserPopup = ({
                          active,
                          setActive,
                          action,
                          pending,
                      }) => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar} = useSelector(globalDataSelector);
    const {usersList} = useSelector(teamsSelector);


    const {t} = useTranslation();

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            setActive(false);
        }
    };

    const usersListOptions = useSelectOptions(usersList, "email", "id");

    useEffect(() => {
        if (topUpBalanceIsActive || exitPopup) {
            setActive(false);
        }
    }, [topUpBalanceIsActive, exitPopup, setActive]);

    const formik = useFormik({
        initialValues: {
            user_id: null,
        },
        validationSchema: Yup.object({
            user_id: Yup.mixed().required(t("requiredField")),
        }),
        onSubmit: async (form) => {
            action(form.user_id?.value);
        },
        validateOnMount: true,
        validateOnBlur: true,
        validateOnChange: true,
        enableReinitialize: true
    });

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                setActive(false);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };

        if (active) {
            document.addEventListener("keydown", handleEscClose);
        }

        return () => {
            document.removeEventListener("keydown", handleEscClose);
        };
    }, [active]);

    const hasError = formik.touched.user_id && Boolean(formik.errors.user_id);

    return (
        <form
            onSubmit={formik.handleSubmit}
            className={`${s.popupWrapper} ${active ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleClosePopup}
        >
            <div className={active ? `${s.popup} ${s.active}` : s.popup}>
                <button
                    onClick={() => setActive(false)}
                    className={s.closePopup}
                    type="button"
                >
                    <SvgSelector id="close-popup"/>
                </button>
                <div className={s.bodyContainer}>
                    <span className={s.iconWrapper}><SvgSelector id='assign-user-icon'/></span>
                    <p className={s.title}>{t('assign_to_user')}</p>
                    <div className={s.selectWrapper}>
                        <p className={s.inputName}>{t("your_users")}</p>
                        <Select
                            value={formik.values.user_id}
                            isClearable={false}
                            options={usersListOptions}
                            onChange={(o) => {
                                formik.setFieldValue("user_id", o)
                            }}
                            isMulti={false}
                            placeholder={t('choose_user')}
                            styles={redirectDropdownStyles}
                            noOptionsMessage={() => t('no_options')}
                            isInvalid={hasError}
                            onBlur={() => formik.setFieldTouched("user_id", true)}
                        />
                            {formik.touched.user_id && formik.errors.user_id ? (
                                <div className={s.error}>{formik.errors.user_id}</div>
                            ) : null}
                    </div>
                </div>
                <div className={s.footer}>
                    <CancelButton
                        text={t('button_cancel')}
                        action={() => {
                            setActive(false)
                        }}
                        width={120}
                    />

                    <PrimaryBtn pending={pending} text={t('confirm')} submit={true}/>
                </div>
            </div>
        </form>
    );
};

export default AssignRecordToUserPopup;
